import './resource-comments.css';
